import { Modal, Button } from "react-bootstrap";
import AddCustomFields from "../../Initiate/NewClientPortal/AddCustomFields";
import { useContext, useEffect, useState } from "react";
import StateContext from "../../../context/State";
import PortalService from '../../../services/portal.service';
import { CustomField } from "../../../types";
import { RPWDataReader, getDataReader } from "../../../../../livedataFuncs";
import { useAppSelector } from "../../../../../redux/hooks";
import { lddStateObject } from "../../../../../redux/reducer";
import { MAX_INTAKE_FIELD_NAME_LENGTH, isIntakeFieldNameTooLong } from "../../../../Settings/ClientConnectFirmSettings/CustomFieldSets/types";


export type AddCustomFieldModalProps = {
    onHideModal: () => void;
    getCustomFieldsData: () => void;
    showModal: boolean;
}

const AddCustomFieldModal = (props: AddCustomFieldModalProps) => {

    const { state } = useContext(StateContext);
    const portalService = new PortalService(state);

    const [customFields, setCustomFields] = useState<CustomField[]>([]);
    const [customFieldSetNames, setCustomFieldSetNames] = useState<string[]>([])

    const [addRow, setAddRow] = useState<boolean>(false);
    const [customFieldSubmitted, setCustomFieldSubmitted] = useState<boolean>(false);
    const [clientInfo, setClientInfo] = useState([]);
    const livedataRootContainer = useAppSelector((state: lddStateObject) => state.currentNavigation.livedataRootContainer);
    let DataReaderObj: RPWDataReader;
    DataReaderObj = getDataReader(livedataRootContainer.dataRoot);
    
    useEffect(() => { getClientInfo(); }, [])

    const getClientInfo = async () => {
        const province = portalService.getProvince();
        const names = DataReaderObj.getUserNames(province);
        setClientInfo(names);
    }

    const hasOverLimitField = customFields.some(f => isIntakeFieldNameTooLong(f.name));

    const setCustomFieldsData = async (portalId) => {
        if (hasOverLimitField) {
            alert(`Each custom field name must be ${MAX_INTAKE_FIELD_NAME_LENGTH} characters or fewer.`);
            return;
        }

        try {
            // Filter and transform fields before submitting
            const processedFields = customFields.map((field) => {
                let next: CustomField = { ...field };
                if (field.perClient) {
                    const clientValues = clientInfo.reduce((obj, clientName) => {
                        obj[clientName] = "";
                        return obj;
                    }, {});
                    next = {
                        ...field,
                        identifier: field.identifier ? field.identifier : JSON.stringify(clientValues)
                    };
                } else if (field.identifier !== null && field.identifier !== undefined) {
                    next = { ...field, identifier: field.identifier };
                }
                return {
                    name: next.name,
                    type: next.type,
                    perClient: next.perClient,
                    value: next.value ?? '',
                    identifier: next.identifier,
                    intakeForm: next.intakeForm ?? null
                };
            });
    
            const res = await portalService.setClientPortalCustomFields(portalId, processedFields, 'afterInit');
            if (res === "Created") {
                setCustomFieldSubmitted(false);
                props.onHideModal();
                props.getCustomFieldsData();
                window.location.reload();
            }
            alert('Submitted Custom Fields!');
        } catch (e) {
            console.log('Unable to set Custom Fields: ', e);
        }
    }

    return (
        <>
            <Modal
                show={props.showModal}
                onHide={props.onHideModal}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                size="xl"
                className="modal-list"
            >
                <Modal.Header closeButton>
                    <h2 id="contained-modal-title-vcenter">{customFields.length === 0 ? 'Add' : 'Edit'} Custom Fields</h2>
                </Modal.Header>

                <Modal.Body>
                    <AddCustomFields
                        setCustomFields={setCustomFields}
                        addRow={addRow}
                        setAddRow={setAddRow}
                        setCustomFieldSetNames={setCustomFieldSetNames}
                        customFieldSetNames={customFieldSetNames}
                        afterInit={true}
                        modalVisible={props.showModal}
                    />
                </Modal.Body>

                <Modal.Footer>
                    {/* <Button variant='outline-primary' onClick={() => { setAddRow(!addRow) }}>
                        Add Row
                    </Button> */}
                    <Button
                        disabled={customFieldSubmitted || hasOverLimitField}
                        title={hasOverLimitField ? `Shorten field names to ${MAX_INTAKE_FIELD_NAME_LENGTH} characters or fewer to submit.` : undefined}
                        onClick={() => {
                            setCustomFieldsData(state.portalId);
                        }}
                    >
                        Submit
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default AddCustomFieldModal;
